import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { PackResponse } from 'app/typings/core/admin/packs/pack';
import type { UpdatePackRequest } from 'app/typings/core/admin/packs/packForm';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

type UpdatePackParams = {
  id: number;
  payload: UpdatePackRequest;
};

export function useUpdatePack() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, payload }: UpdatePackParams) =>
      apiMutation(
        'PATCH',
        { path: ENDPOINTS.updatePack, params: { id: id.toString() } },
        payload
      ) as Promise<PackResponse>,
    onSuccess: (response, variables) => {
      message.success('Package successfully updated');

      queryClient.setQueryData(
        [CORE_QUERY_KEYS.pack, { id: variables.id.toString() }],
        response
      );

      queryClient.invalidateQueries([CORE_QUERY_KEYS.pack, variables.id]);
    },
  });
}
